'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import PopTopicCardSkeleton from '@fe-news/components/molecules/PopTopicCardSkeleton';
import LazyLoadComponent from '@fe-news/components/LazyLoadComponent/LazyLoadComponent';

const InfiniteCard = dynamic(() => import('./InfiniteCard'), {
  loading: () => <PopTopicCardSkeleton />,
  ssr: false
});

type InfiniteCardLazyProps = {
  id: string;
};

const InfiniteCardLazy = ({ id }: InfiniteCardLazyProps) => {
  return (
    <Suspense fallback={<PopTopicCardSkeleton />}>
      <LazyLoadComponent exposureRate={0.1} PlaceholderComponent={<PopTopicCardSkeleton />}>
        <InfiniteCard id={id} />
      </LazyLoadComponent>
    </Suspense>
  );
};

export default InfiniteCardLazy;
